import { IOrderQuery } from "../../models/order/query";
import {
  IOrder,
  IOrderDetails,
  IOrderShort, IRatedOrder,
} from "../../models/order/response";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import toggleLoading from "../../utils/helpers/xor";
import paramsReducer from "../base/base-reducer";
import { QueryAction } from "../base/base-reducer";
import { IInternalState, OrderLoading } from "./context";

type Action =
  | { type: "LOADING"; payload: { loading: OrderLoading | OrderLoading[] } }
  | { type: "SET_LIST"; payload: { list: IBaseListingResponse<IOrder> } }
  | {
      type: "SET_LIST_SHORT";
      payload: { listShort: IBaseListingResponse<IOrderShort> };
    }
  | {
      type: "SET_LIST_RATED";
      payload: { listRated: IBaseListingResponse<IRatedOrder> };
    }
  | { type: "SET_DETAILS"; payload: { details?: IOrderDetails } }
  | QueryAction<IOrderQuery>;

const reducer = (state: IInternalState, action: Action): IInternalState => {
  switch (action.type) {
    case "LOADING": {
      return {
        ...state,
        loading: toggleLoading(state.loading, action.payload.loading),
      };
    }
    case "SET_LIST": {
      return {
        ...state,
        list: action.payload.list,
      };
    }
    case "SET_LIST_SHORT": {
      return {
        ...state,
        listShort: action.payload.listShort,
      };
    }
    case "SET_LIST_RATED": {
      return {
        ...state,
        listRated: action.payload.listRated,
      };
    }
    case "SET_DETAILS": {
      return {
        ...state,
        details: action.payload.details,
      };
    }

    default: {
      return paramsReducer(state, action);
    }
  }
};

export default reducer;
